export enum WizardStep {
  OCCASION = "occasion",
  GREET = "greet",
  PERSONAL_GREET = "personal-greet",
  PREVIEW = "preview",
  PRODUCT_PAGE = "product-page",
}

export type WizardStepType = WizardStep;
